import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Divider,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { useQuery } from "react-query";
import { getVisitByID } from "../../api/services/scheduling";
import { getClientArea } from "../../api/services/Client";
import SelectRun from "./SelectRun";
import { QK } from "../../base/qk";
import ScheduleJobDetails from "./ScheduleJobDetails";

const AssignEmployee = ({ visitId, clientId }) => {
  const [area, setArea] = useState(null);
  const [areaName, setAreaName] = useState("");
  const [isRunAdded, setIsRunAdded] = useState(false);

  const { data: visit } = useQuery(
    QK.visitDetails,
    () => getVisitByID(visitId),
    {
      enabled: !!visitId,
    }
  );

  const { data } = useQuery(QK.clientArea, () => getClientArea(clientId), {
    enabled: !!clientId,
    onSuccess: (data) => {
      setArea(data.area);
    },
  });

  return (
    <Box
      sx={{
        maxWidth: "800px",
        mx: "auto",
        p: 3,
        bgcolor: "white",
        borderRadius: "12px",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        border: "1px solid #E2E8F0",
      }}
    >
      <Typography
        variant="h6"
        align="center"
        fontWeight={600}
        sx={{ color: "#1A1A2E", mb: 2 }}
      >
        Assign Run Employee
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Paper
        elevation={0}
        sx={{
          p: 3,
          bgcolor: "#F8FAFC",
          borderRadius: "8px",
          border: "1px solid #E2E8F0",
          mb: 3,
        }}
      >
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={8}>
            <SelectRun
              area={area}
              visitId={visitId}
              setIsRunAdded={setIsRunAdded}
            />
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ mt: 3 }}>
        <ScheduleJobDetails
          visitId={visitId}
          area={area}
          isRunAdded={isRunAdded}
          area_name={areaName}
        />
      </Box>
    </Box>
  );
};

export default AssignEmployee;